import { Controller } from 'react-hook-form';
import { RadioButton } from 'primereact/radiobutton';

export default function SingleChoice({ control, name, options = [], disabled }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div className="d-flex flex-wrap">
          {options.map((option, i) => (
            <div key={option.value} className="d-flex align-items-center w-50 mt-2">
              <RadioButton
                inputId={`${name}-${i}`}
                name={name}
                value={option.value}
                onChange={(e) => field.onChange(e.value)}
                checked={field.value === option.value}
                disabled={disabled}
              />
              <label htmlFor={`${name}-${i}`} className="ms-2">
                {option?.label}
              </label>
            </div>
          ))}
        </div>
      )}
    />
  );
}
